import { render, staticRenderFns } from "./KuangJia.vue?vue&type=template&id=95675a62&scoped=true&"
import script from "./KuangJia.vue?vue&type=script&lang=js&"
export * from "./KuangJia.vue?vue&type=script&lang=js&"
import style0 from "./KuangJia.vue?vue&type=style&index=0&id=95675a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95675a62",
  null
  
)

export default component.exports